import type { ProcessCellForExportParams } from "ag-grid-enterprise";

// ─── Shared export formatting utilities ────────────────────────────────────
// Used by both AgGridComponent (client-side) and AgGridSsrmComponent (SSRM)
// for CSV/Excel cell value formatting during export.

/**
 * Formats a cell value for export.
 * - Group rows: appends the child count in parentheses.
 * - Array values: joins with a space separator.
 * - All other values: returned as-is.
 */
export function formatCellValue(params: ProcessCellForExportParams): string {
  const { value, node } = params;
  if (node?.group) {
    if (value == null || value === "") return "";
    const count = node.allChildrenCount ?? node.childrenAfterFilter?.length ?? 0;
    return `${value} (${count})`;
  }
  if (Array.isArray(value)) {
    return (value as unknown[]).join(" ");
  }
  return value as string;
}
